<template>
  <div class="page-img-detail">
    <img :src="url" alt="" />
  </div>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      url: "",
    };
  },
  mounted() {
    this.url = this.$route.query.url;
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.page-img-detail {
  width: 100%;
  min-height: 100vh;
  img {
    width: 100%;
    height: auto;
  }
}
</style>
